function parseH5ReportResponse(response) {
  const payload = response && response.code !== undefined ? response : response && response.data
  if (!payload || payload.code !== 1 || !payload.data) {
    return {
      state: 'error',
      report: null,
    }
  }

  if (payload.data.expired) {
    return {
      state: 'expired',
      report: null,
    }
  }

  return {
    state: 'normal',
    report: payload.data,
  }
}

module.exports = {
  parseH5ReportResponse,
}
